export enum Roles {
	SUPER_ADMIN = 'super_admin',
	MANAGER = 'Manager',
	EMPLOYEE = 'Employee',
	HR = 'HR',
	HR_ASSISTANCE = 'HR assistance',
}
